import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import { getScreenSelector, ScreenWidthMinXXXLarge, ScreenWidthMaxLarge, Stack, ScreenWidthMinSmall, ScreenWidthMaxMedium, ScreenWidthMaxSmall } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { AppContext } from '../context/context.esm.js';
import { unifiedHeaderData, headerData } from '../../data/data.esm.js';
import { useBreakpoint } from '@agoras/hooks';
import AllPanel from './AllPanel/AllPanel.esm.js';
import TopHeader from './TopHeader/TopHeader.esm.js';
import AllButton from './AllPanel/Header/AllButton/AllButton.esm.js';
import Searchbar from '../Searchbar/Searchbar.esm.js';
import { UNIFIED_SEARCHBAR_DROPDOWN, SEARCHBAR_DEFAULTS } from '../Searchbar/constants.esm.js';
import MegaMenu from './MegaMenu/MegaMenu.esm.js';
import { defaultAppSourceNavigation } from '../../router/appsource.esm.js';
import logger from '@agoras/logger';
import { headerContext } from './context.esm.js';

/* istanbul ignore file */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var stackStyles = function(isSearchInHero) {
    var _obj;
    return {
        root: (_obj = {
            top: 0,
            width: '100%',
            minWidth: ScreenWidthMinSmall,
            height: '92px',
            boxShadow: '0 7.6px 11.8px 0 #0000001e',
            position: 'sticky',
            zIndex: '5',
            backgroundColor: 'white',
            padding: '0 32px'
        }, _define_property(_obj, "@media screen and (max-width: ".concat(ScreenWidthMaxLarge, "px)"), {
            height: isSearchInHero ? '52px' : '104px',
            padding: '0 28px'
        }), _define_property(_obj, "@media screen and (max-width: ".concat(ScreenWidthMaxMedium, "px)"), {
            padding: '0 16px'
        }), _define_property(_obj, "@media screen and (max-width: ".concat(ScreenWidthMaxSmall, "px)"), {
            padding: '0 8px'
        }), _obj)
    };
};
var _obj;
var innerStackStyles = {
    root: (_obj = {
        height: '40px'
    }, _define_property(_obj, getScreenSelector(ScreenWidthMinXXXLarge, undefined), {
        margin: '0 auto',
        width: ScreenWidthMinXXXLarge - 64
    }), _define_property(_obj, getScreenSelector(undefined, ScreenWidthMaxLarge), {
        height: '52px'
    }), _define_property(_obj, '& .ms-layer', {
        display: 'none'
    }), _obj)
};
var getData = function(param) {
    var unifiedExperience = param.unifiedExperience;
    // @ts-expect-error types require refactoring...
    return unifiedExperience ? unifiedHeaderData : headerData;
};
var Header = function(param) {
    var navigate = param.navigate, userProps = param.userProps, locale = param.locale, location = param.location, market = param.market, onLocaleChange = param.onLocaleChange, onMarketChange = param.onMarketChange, searchProps = param.searchProps, currentView = param.currentView, _param_unifiedExperience = param.unifiedExperience, unifiedExperience = _param_unifiedExperience === void 0 ? false : _param_unifiedExperience;
    var _useState = _sliced_to_array(useState(''), 2), openPanelKey = _useState[0], setOpenPanelKey = _useState[1];
    var data = useMemo(function() {
        return getData({
            unifiedExperience: unifiedExperience
        });
    }, [
        unifiedExperience
    ]);
    var _useBreakpoint = _sliced_to_array(useBreakpoint('xl', 'xxxl'), 1), isAboveXL = _useBreakpoint[0];
    var _useBreakpoint1 = _sliced_to_array(useBreakpoint('sm', 'lg'), 1), isBetweenSmallAndLarge = _useBreakpoint1[0];
    var _ref = userProps !== null && userProps !== void 0 ? userProps : {}, openSignInModal = _ref.openSignInModal, onLogout = _ref.onLogout, onSignUp = _ref.onSignUp, _ref_signedIn = _ref.signedIn, signedIn = _ref_signedIn === void 0 ? false : _ref_signedIn, _ref_loading = _ref.loading, loading = _ref_loading === void 0 ? false : _ref_loading, favoritesCount = _ref.favoritesCount;
    var _useBoolean = _sliced_to_array(useBoolean(false), 2), isAllPanelOpen = _useBoolean[0], _useBoolean_ = _useBoolean[1], openAllPanel = _useBoolean_.setTrue, dismissAllPanel = _useBoolean_.setFalse;
    var allPanelButtonRef = useRef();
    var _ref1 = searchProps !== null && searchProps !== void 0 ? searchProps : {
        onSearch: function() {
            throw Error('onSearch not implemented');
        },
        filters: [],
        isSearchInHero: false
    }, onSearch = _ref1.onSearch, filters = _ref1.filters, isSearchInHero = _ref1.isSearchInHero;
    var memoizedStackStyles = useMemo(function() {
        return stackStyles(isSearchInHero);
    }, [
        isSearchInHero
    ]);
    var handleNavigation = function(options) {
        var _options_query;
        options.query = (_options_query = options.query) !== null && _options_query !== void 0 ? _options_query : {};
        if (typeof navigate === 'function' && !options.useDefault) {
            navigate(options);
            return;
        }
        defaultAppSourceNavigation(_object_spread_props(_object_spread({}, options), {
            params: _object_spread_props(_object_spread({}, options.params), {
                locale: locale
            })
        }));
    };
    useEffect(function() {
        var openBillingRegionPanel = function() {
            logger.info(JSON.stringify({
                key: 'languageAndRegion'
            }), _object_spread({
                action: 'Footer',
                actionModifier: 'Click'
            }, headerContext));
            setOpenPanelKey('languageAndRegion');
        };
        var localePickerFooterElement = document.getElementById('locale-picker-link');
        if (localePickerFooterElement) {
            localePickerFooterElement.addEventListener('click', openBillingRegionPanel);
        }
        return function() {
            localePickerFooterElement === null || localePickerFooterElement === void 0 ? void 0 : localePickerFooterElement.removeEventListener('click', openBillingRegionPanel);
        };
    }, [
        setOpenPanelKey
    ]);
    var handleOpenAllPanel = useCallback(function() {
        logger.info('', _object_spread({
            action: 'AllMenu',
            actionModifier: 'Open panel'
        }, headerContext));
        openAllPanel();
    }, [
        openAllPanel
    ]);
    var handleDismissAllPanel = useCallback(function() {
        logger.info('', _object_spread({
            action: 'AllMenu',
            actionModifier: 'Close panel'
        }, headerContext));
        dismissAllPanel();
    }, [
        dismissAllPanel
    ]);
    var handleMarketChange = useCallback(function() {
        var _ref = _async_to_generator(function(marketCode) {
            var err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            onMarketChange === null || onMarketChange === void 0 ? void 0 : onMarketChange(marketCode)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        logger.error("Failed to invoke onMarketChange callback. Error: ".concat(JSON.stringify(err)));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(marketCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onMarketChange
    ]);
    var handleLocaleChange = useCallback(function(locale) {
        try {
            onLocaleChange === null || onLocaleChange === void 0 ? void 0 : onLocaleChange(locale);
        } catch (err) {
            logger.error("Failed to invoke onLocaleChange callback. Error: ".concat(JSON.stringify(err)));
        }
    }, [
        onLocaleChange
    ]);
    return /*#__PURE__*/ jsx(AppContext.Provider, {
        value: {
            navigate: handleNavigation,
            user: {
                favoritesCount: favoritesCount,
                signedIn: signedIn,
                loading: loading
            },
            openSignInModal: openSignInModal,
            onLogout: onLogout,
            onSignUp: onSignUp,
            location: location,
            searchProps: {
                onSearch: onSearch,
                filters: filters,
                isSearchInHero: isSearchInHero
            },
            openPanelKey: openPanelKey,
            setOpenPanelKey: setOpenPanelKey,
            locale: locale,
            onLocaleChange: handleLocaleChange,
            market: market,
            onMarketChange: handleMarketChange,
            unifiedExperience: unifiedExperience
        },
        children: /*#__PURE__*/ jsxs(Stack, {
            as: "header",
            styles: memoizedStackStyles,
            children: [
                /*#__PURE__*/ jsx(TopHeader, {
                    currentView: currentView,
                    isAllPanelOpen: isAllPanelOpen,
                    dismissAllPanel: handleDismissAllPanel,
                    openAllPanel: handleOpenAllPanel,
                    allButtonRef: allPanelButtonRef
                }),
                (isAboveXL || isBetweenSmallAndLarge && !searchProps.isSearchInHero) && /*#__PURE__*/ jsxs(Stack, {
                    styles: innerStackStyles,
                    horizontal: true,
                    verticalAlign: "center",
                    horizontalAlign: "start",
                    tokens: {
                        childrenGap: 24
                    },
                    children: [
                        isAboveXL && /*#__PURE__*/ jsxs(Fragment, {
                            children: [
                                /*#__PURE__*/ jsx(AllButton, {
                                    renderText: true,
                                    isOpen: isAllPanelOpen,
                                    openPanel: handleOpenAllPanel,
                                    dismissPanel: handleDismissAllPanel,
                                    componentRef: allPanelButtonRef
                                }),
                                /*#__PURE__*/ jsx(MegaMenu, {})
                            ]
                        }),
                        isBetweenSmallAndLarge && !searchProps.isSearchInHero && /*#__PURE__*/ jsx(Searchbar, {
                            currentView: currentView,
                            filters: filters,
                            onSearch: onSearch,
                            mfeContext: headerContext,
                            dropdownOptions: unifiedExperience ? UNIFIED_SEARCHBAR_DROPDOWN : SEARCHBAR_DEFAULTS.DROPDOWN
                        })
                    ]
                }),
                /*#__PURE__*/ jsx(AllPanel, {
                    isOpen: isAllPanelOpen,
                    dismissPanel: handleDismissAllPanel,
                    data: data,
                    allButtonRef: allPanelButtonRef
                })
            ]
        })
    });
};

export { Header as default };
